// @ts-nocheck
function iconOptions(type, angle) {
  if (type === 'viewport') {
    return {
      path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW,
      scale: 10,
      strokeColor: '#eb1300',
      strokeWeight: 3,
      strokeOpacity: 0.7,
      fillColor: '#eb1300',
      fillOpacity: 0.4,
      rotation: angle,
    };
  }

  return {
    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    scale: 5,
    strokeColor: '#000000',
    strokeWeight: 3,
    strokeOpacity: 0.8,
    fillColor: '#000000',
    fillOpacity: 0.8,
    rotation: angle,
    anchor: new google.maps.Point(0, 3),
  };
}

export default class CurrentViewportMarkerManager {
  constructor(map) {
    this._map = map;
    this._viewportMarker = new google.maps.Marker();
    this._courseMarker = new google.maps.Marker();
  }

  update(currentViewPoint) {
    if (!currentViewPoint) {
      return;
    }

    if (currentViewPoint.viewportAngle != null) {
      this._viewportMarker.setOptions({
        position: currentViewPoint.location,
        icon: iconOptions('viewport', currentViewPoint.viewportAngle),
      });

      if (!this._viewportMarker.getMap()) {
        this._viewportMarker.setMap(this._map);
      }
    } else {
      this._viewportMarker.setMap(null);
    }

    if (currentViewPoint.courseAngle != null) {
      this._courseMarker.setOptions({
        position: currentViewPoint.location,
        icon: iconOptions('course', currentViewPoint.courseAngle),
      });

      if (!this._courseMarker.getMap()) {
        this._courseMarker.setMap(this._map);
      }
    } else {
      this._courseMarker.setMap(null);
    }
  }
}
